__turbopack_context__.v({
  "dialog": "styles-module__Pr7r6G__dialog",
  "dialogButton": "styles-module__Pr7r6G__dialogButton",
});
